import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  Credentials,
  initialState,
  RecoveryStep
} from '@/modules/security/passwordRecovery/store/recoverySlice/initialState.ts'

const recoverySlice = createSlice({
  name: 'recoverySlice',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCurrentStep: (state, action: PayloadAction<RecoveryStep>) => {
      state.currentStep = action.payload
    },
    setCredentials: (state, action: PayloadAction<Credentials>) => {
      state.credentials = action.payload
    },
    reset: () => initialState
  }
})

export const recoveryActions = recoverySlice.actions
export const { reducer: recoveryReducer } = recoverySlice
